import DOMPurify from 'dompurify';

// Sanitize plain text input
// Removes HTML tags and dangerous characters
export function sanitizeText(input) {
  if (!input) return '';
  return DOMPurify.sanitize(input, {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: []
  }).trim();
}

// Sanitize and truncate
export function sanitizeAndTrim(input, maxLength = 500) {
  return sanitizeText(input).slice(0, maxLength);
}

// Sanitize email
export function sanitizeEmail(input) {
  if (!input) return '';
  return input.toLowerCase().trim().slice(0, 254);
}

// Sanitize number input
export function sanitizeNumber(input) {
  const num = parseFloat(input);
  return isNaN(num) ? 0 : num;
}
